import DualChoiceWarningModal from './DualChoiceWarningModal'

export default DualChoiceWarningModal
